/**
 * Template dropdown styles - layout and interactive states.
 * Colors come from MUI theme.
 */

import { SxProps, Theme } from '@mui/material';

export const templateDropdownStyles: Record<string, SxProps<Theme>> = {
  container: {
    mb: 0,
  },
  formControl: {
    width: '100%',
  },
  select: {
    '& .MuiSelect-select': { padding: '10px 12px' },
    '& .MuiSelect-icon': { fontSize: '24px' },
  },
  menuPaper: {
    minWidth: 250,
    maxWidth: 'none',
    mt: 0.5,
    zIndex: 1000001,
  },
  menuList: {
    py: 0.5,
  },
  menuBackdrop: {
    zIndex: 1000001,
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
      backdropFilter: 'none',
    },
  },
  placeholderText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '330px',
  },
  selectedValueText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '330px',
    color: 'text.primary',
  },
  statusContainer: {
    mt: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: '20px',
  },
  statusText: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.25,
    whiteSpace: 'nowrap',
    color: 'text.secondary',
  },
  statusTextError: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.25,
    whiteSpace: 'nowrap',
    color: 'error.main',
  },
  hiddenMenuItem: {
    display: 'none',
  },
  divider: {
    borderTop: 1,
    borderColor: 'divider',
    margin: '8px 0',
  },
  groupHeader: {
    bgcolor: 'background.paper',
    color: 'text.secondary',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '28px',
    px: 1.5,
    textTransform: 'uppercase',
  },
  legacyTrigger: {
    py: 0.75,
    px: 1.5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
    minHeight: 'auto',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: 'custom.menuHover',
    },
    '&:focus': {
      bgcolor: 'custom.menuHover',
      outline: 'none',
    },
  },
  legacyTriggerText: {
    fontSize: '12px',
    fontWeight: 500,
    color: 'text.primary',
  },
  chevronIcon: {
    fontSize: '18px',
    color: 'text.secondary',
  },
  legacySubmenuPaper: {
    minWidth: 280,
    maxWidth: 350,
    maxHeight: 300,
    overflowY: 'auto',
    mt: 0.5,
  },
  menuItem: {
    py: 0.75,
    px: 1.5,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    minHeight: 'auto',
    whiteSpace: 'normal',
    '&.Mui-disabled': {
      opacity: 0.48,
      pointerEvents: 'auto',
    },
  },
  disabledMenuItemContentWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    width: '100%',
  },
  tooltipPopper: {
    zIndex: 1000003,
  },
  templateItemIcon: {
    mt: 0.25,
    flexShrink: 0,
    color: 'text.secondary',
    '& svg': {
      color: 'inherit',
      fontSize: '14px',
    },
  },
  templateItemContent: {
    flexGrow: 1,
    minWidth: 0,
    flex: 1,
  },
  templateItemName: {
    fontSize: '12px',
    mb: 0.25,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  templateItemDescription: {
    fontSize: '10px',
    display: 'block',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  newBadge: {
    bgcolor: '#fef3c7',
    color: '#92400e',
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '4px',
    marginLeft: '8px',
    flexShrink: 0,
  },
};

export const getLegacyTriggerStyles = (isOpen: boolean): SxProps<Theme> => ({
  ...templateDropdownStyles.legacyTrigger,
  bgcolor: isOpen ? 'custom.menuActive' : 'transparent',
});
